import { Component, input } from '@angular/core';
import { Router } from '@angular/router';

import {
  BreadcrumbRouterComponent,
  ContainerComponent,
  DropdownComponent,
  DropdownItemDirective,
  DropdownMenuDirective,
  DropdownToggleDirective,
  HeaderComponent,
  HeaderNavComponent,
  HeaderTogglerDirective,
  NavItemComponent,
  NavLinkDirective,
  SidebarToggleDirective,
} from '@coreui/angular';

import { IconDirective } from '@coreui/icons-angular';
import { AuthenticationService } from '../../../services/admin/authentication.service';
import { ApplicationsService } from '../../../services/applications/applications.service';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  standalone: true,
  imports: [ContainerComponent, HeaderTogglerDirective, SidebarToggleDirective, IconDirective, HeaderNavComponent, NavItemComponent, NavLinkDirective, BreadcrumbRouterComponent, DropdownComponent, DropdownToggleDirective, DropdownMenuDirective, DropdownItemDirective]
})
export class DefaultHeaderComponent extends HeaderComponent {

  constructor(private authenticationService: AuthenticationService, public applicationsService: ApplicationsService, private router: Router) {
    super();
  }

  sidebarId = input('sidebar1');
  
  logout() {
    this.authenticationService.logout();
  }

  getCurrentUserEmail() : String | null {
    return this.authenticationService.getCurrentUserEmail();
  }

  getSelectedApplicationName(): string {
    return this.applicationsService.applications.find(a => a.id === this.applicationsService.applicationIdSelected)?.name ?? '';
  }

  selectApplication(applicationId: number): void {
    this.applicationsService.changeApplication(applicationId);
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    });
  }
}
